/* Copyright (C) 2021 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Mujica <jmujica@smartboxtv.com>
 */

import { observable, action, flow, toJS } from 'mobx';
import fetch from '../fetch';
import ErrorsStore from './errorsStore';
import _ from '../translations';
import forEach from 'lodash/forEach';
class FilesStore {
    @observable fileUploadResult = {};
    @observable fileUploadConfig = {};

    constructor() {
        this.baseUrl = '/api/assets/s3/upload';
        this.config = {
            development: {
                bucket: 'fx-nunchee-assets',
            },
            staging: {
                bucket: 'fx-nunchee-assets',
            },
            production: {
                bucket: 'fx-nunchee-assets',
            },
        };
    };

    @action.bound
    upload = flow(function* (file = {}, route = '', app = '') {
        if (!file) return;
        if (!this.fileUploadConfig.meta) yield this.getBucketConfiguration(route, app);
        const { form } = this.buildFileForm(file);
        try {
            const result = yield fetch.submit({
                form,
                url: this.fileUploadConfig.bucket
            });
            if (result.error) {
                console.error(result);
            };
            this.fileUploadResult = result;
            return result;
        } catch (e) {
            ErrorsStore.addError(e, _('Could not upload file'));
            console.warn(e);
        };
    });

    @action.bound
    getBucketConfiguration = flow(function* (route = '', app) {
        const env = process.env.REACT_APP_SETTINGS_ENV || process.env.NODE_ENV;
        try {
            const params = {
                bucket: this.config[env].bucket,
                app: app
            };
            const result = yield fetch.get({
                url: `${this.baseUrl}${route}`,
                params,
            });
            if (result.error) {
                ErrorsStore.addError(result, _('Could not get S3 credentials'));
            };
            this.fileUploadConfig = result;
        } catch (e) {
            ErrorsStore.addError(e, _('Could not get S3 credentials'));
            console.warn(e);
        };
    });

    buildFileForm = (file) => {
        try {
            const config = toJS(this.fileUploadConfig);
            const form = new FormData();
            let urlKey = '';
            forEach(config.meta, (field, key) => {
                if (key === 'key') {
                    urlKey = this.generateFileKey(file);
                    form.append(key, urlKey);
                } else {
                    form.append(key, field);
                };
            });
            form.append('file', file);
            return { form, urlKey };
        } catch (e) {
            console.error('Error building file form', e);
        };
    };

    generateFileKey = (file) => {
        // eslint-disable-next-line
        return this.fileUploadConfig.meta.key.replace('${filename}', file.name);
    };

};

export default new FilesStore();